import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Store from "../store/index.js";
import Meta from "vue-meta";

import { Token_EmailEncrypt, Token_Email /* Profile_Get*/ } from "@/apis/api";

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "首頁",
      requiresAuth: false,
    },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/signin",
    name: "SignIn",
    component: () => import("../views/SignIn.vue"),
    meta: {
      title: "登入",
      requiresAuth: false,
    },
  },
  {
    path: "/loginSuccess",
    name: "LoginSuccess",
    component: () => import("../views/LoginSuccess.vue"),
    meta: {
      title: "登入成功",
      requiresAuth: false,
    },
  },
  {
    path: "/serviceTemp",
    name: "ServiceTemp",
    component: () => import("../views/Services/ServiceTemp.vue"),
    children: [
      {
        path: "/service",
        name: "Service",
        component: () => import("../views/Services/Service.vue"),
        meta: {
          title: "服務首頁",
          requiresAuth: false,
        },
      },
      {
        path: "/adsApply",
        name: "AdsApply",
        component: () => import("../views/Services/AdsApply.vue"),
        meta: {
          title: "廣告申請",
          requiresAuth: false,
        },
      },
      {
        path: "/ads",
        name: "Ads",
        component: () => import("../views/Services/Ads.vue"),
        meta: {
          title: "廣告總覽",
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/profileTemp",
    name: "ProfileTemp",
    component: () => import("../views/Profiles/ProfileTemp.vue"),
    children: [
      {
        path: "/profile",
        name: "Profile",
        component: () => import("../views/Profiles/Profile.vue"),
        meta: {
          title: "個人資訊",
          requiresAuth: true,
        },
      },
      {
        path: "/accountSetting",
        name: "AccountSetting",
        component: () => import("../views/Profiles/AccountSetting.vue"),
        meta: {
          title: "帳號與安全",
          requiresAuth: true,
        },
      },
      {
        path: "/share",
        name: "Share",
        component: () => import("../views/Profiles/Share.vue"),
        meta: {
          title: "分享",
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/adminTemp",
    name: "AdminTemp",
    component: () => import("../views/Admin/AdminTemp.vue"),
    children: [
      {
        path: "/tempadmin",
        name: "TempAdmin",
        component: () => import("../views/Admin/TempAdmin.vue"),
        meta: {
          title: "管理後台首頁",
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/center",
    name: "Center",
    component: () => import("../views/Member/Center.vue"),
    meta: {
      title: "小芋頭會員",
      requiresAuth: true,
    },
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/Member/Order.vue"),
    meta: {
      title: "購買飼料點數",
      requiresAuth: true,
    },
  },
  {
    path: "/order/success",
    name: "OrderSuccess",
    component: () => import("../views/Member/OrderSuccess.vue"),
    meta: {
      title: "購買飼料點數成功",
      requiresAuth: true,
    },
  },
  {
    path: "/upgrade",
    name: "Upgrade",
    component: () => import("../views/Member/Upgrade.vue"),
    meta: {
      title: "金豐小芋頭平台創業",
      requiresAuth: false,
    },
  },
  {
    path: "/disclaimer",
    name: "Disclaimer",
    component: () => import("../views/Disclaimer.vue"),
    meta: {
      title: "免責聲明",
      requiresAuth: false,
    },
  },
  {
    path: "/privacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
    meta: {
      title: "隱私權政策",
      requiresAuth: false,
    },
  },
  {
    path: "/images",
    name: "Images",
    component: () => import("../views/Images.vue"),
    meta: {
      title: "圖片",
      requiresAuth: false,
    },
  },

  {
    path: "/error",
    name: "Error",
    component: () => import("../views/Error.vue"),
    meta: {
      title: "error",
      requiresAuth: false,
    },
  },
  {
    path: "*",
    redirect: "/error",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  Store.commit("GetUserDevice"); // 取得使用者裝置
  let userDevice = Store.state.userDevice;

  // 看有沒有串字串
  if (userDevice.line) {
    const redirectUrl = to.fullPath.includes("?") ? to.fullPath + "&openExternalBrowser=1" : to.fullPath + "?openExternalBrowser=1";
    window.location.href = redirectUrl;
    return false;
  }

  if (typeof window.localStorage === "undefined") {
    alert("您的瀏覽器不支援 Web Storage，請更換支援的瀏覽器。");
  }

  // 先一律至頂
  window.scrollTo(0, 0);
  // 抓queryString (from=) 並在Vuex設定從哪個網站來
  Store.commit("SetFromSiteConfig", to.query.from);
  // 抓queryString (from_cmid=) 並在Vuex設定從哪個社群來
  Store.commit("SetFromSiteCmidConfig", to.query.from_cmid);

  // #region 看router 判斷要不要背景圖
  Store.state.isSerivceRouter = ["ServiceTemp", "ProfileTemp"].includes(to.matched[0]?.name) || ["Home", "Share", "Center", "Order", "OrderSuccess", "Upgrade"].includes(to.name);
  //#endregion

  // ✅ 登入權限判斷改為 meta.requiresAuth 判斷
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth) {
    // && !Store.state.signinStatus
    try {
      const res = await Token_EmailEncrypt(); // 驗證 token 成功
      const res_email = await Token_Email();
      localStorage.setItem("_signinEmail", res_email.data);

      Store.state.username = res.data;
      Store.state.signinStatus = true;

      // 可選：抓取額外個資
      //   await Profile_Get(res.data)
      //     .then((r) => {
      //       Store.state.userPhoto = r.data.data.photoUrl;
      //     })
      //     .catch(() => {
      //       Store.state.userPhoto = null;
      //     });

      return next(); // 通過驗證
    } catch (err) {
      // token 驗證失敗，導向登入頁
      Store.state.username = null;
      Store.state.signinStatus = false;
      return next({ name: "SignIn" });
    }
  }

  next();
});

export default router;
